import { useTranslation } from 'react-i18next';
import Alert from '../../styled-components/components/Alert';
import Container from '../../styled-components/components/Container';
import { PageSection } from '../../styled-components/components/PageSection';
import PageHeader from '../../styled-components/structures/PageHeader';

const NotFound = () => {
  const tActivity = useTranslation('activity').t;

  const tOther = useTranslation('other').t;

  return (
    <Container>
      <PageHeader
        heading={tOther('pageNotFound.heading')}
        preamble={<p>{tOther('pageNotFound.description')}</p>}
        breadcrumbs={[
          {
            displayName: tActivity('activity'),
            link: {
              to: '/',
              title: tActivity('activity'),
            },
          },
          {
            displayName: tOther('pageNotFound.heading'),
          },
        ]}
      />
      <PageSection>
        <Alert
          tone="error"
          heading={tOther('pageNotFound.alertHeading') || undefined}
          message={tOther('pageNotFound.alertMessage')}
        />
      </PageSection>
    </Container>
  );
};

export default NotFound;
